import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealsBoardQueryKeys } from '@crm/entities/deals-board';

import { createDealMutationOptions } from '../api';

export const useCreateDealMutation = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        ...createDealMutationOptions(t('crm.addNewDeal.defaultDealName')),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealsBoardQueryKeys.board() });
        },
    });
};
